import { render, staticRenderFns } from "./clientNew.vue?vue&type=template&id=2655f513&scoped=true&"
import script from "./clientNew.vue?vue&type=script&lang=js&"
export * from "./clientNew.vue?vue&type=script&lang=js&"
import style0 from "./clientNew.vue?vue&type=style&index=0&id=2655f513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2655f513",
  null
  
)

export default component.exports